export const SAVE_POD_TIME_DELAY = 3000;
export const SAVE_PARENT_PRODUCT_TIME_DELAY = 5000;
export const SEARCH_PRODUCTS_TIME_DELAY = 10;
export const POD_TABS_LIST = [
    {key: 'details', label: 'Details'},
    /*{key: 'categories', label: 'Categories'},*/
    {key: 'parent-products', label: 'Parent Products'},
    {key: 'products', label: 'Products'},
    {key: 'product-colors', label: 'Product Colors'},
    {key: 'upload-products', label: 'Upload Products'},
    {key: 'sync-products', label: 'Sync Products'},
];

// export const DEFAULT_POD_TAB = {key: 'parent-products', label: 'Parent Products'};
// export const DEFAULT_POD_TAB = {key: 'products', label: 'Products'};
// export const DEFAULT_POD_TAB = {key: 'upload-products', label: 'Upload Products'};
export const DEFAULT_POD_TAB = {key: 'details', label: 'Details'};

export const POD_KEY_PREFIX = {
    CATEGORY: 'category',
};

export const DEFAULT_PRODUCT_UPLOAD_TAB = {key: 'fields', label: 'Fields'};
export const PRODUCT_UPLOAD_TABS_LIST = [
    {key: 'fields', label: 'Fields Mapping'},
    {key: 'product-summary', label: 'Products Summary'},
    /*{key: 'categories', label: 'Categories'},*/
    {key: 'products', label: 'Products'},
];

export const PRODUCT_COLOR_FILTER_LIST = [
    {key: 'all', label: 'All Colors'},
    {key: 'single', label: 'Single Colors'},
    {key: 'multi', label: 'Multiple Colors'},
];

export const PRODUCT_SIZE_FILTER_LIST = [
    {key: 'single-measurement', label: 'Single Measurement'},
    {key: 'multi-measurements', label: 'Multiple Measurements'},
];

export const PRODUCT_DETAIL_KEY = {
    VARIANT_ID: 'variantId',
    CATEGORY: 'category',
    PRODUCT_TYPE: 'productType',
    COLOR: 'color',
    SIZE: 'size',
    SIZE_TYPE: 'sizeType',
    PARENT: 'parent',
    KEY: 'key',
    NAME: 'name',
    TITLE: 'title',
    HEIGHT_INCH: 'heightInch',
    WIDTH_INCH: 'widthInch',
    HEIGHT_PIXEL: 'heightPixel',
    WIDTH_PIXEL: 'widthPixel',
};

export const PRODUCT_FIELDS_LIST = [
    {
        label: "Variant Id",
        attribute: "variantId"
    },
    /*{
        label: "SKU",
        attribute: "sku"
    },*/
    {
        label: "Name",
        attribute: "name"
    },
    {
        label: "Product Type",
        attribute: "productType"
    },
    {
        label: "Image",
        attribute: "image"
    },
    {
        label: "Height (Inch)",
        attribute: "heightInch"
    },
    {
        label: "Length (Inch)",
        attribute: "lengthInch"
    },
    {
        label: "Width (Inch)",
        attribute: "widthInch"
    },
    {
        label: "Price (USD)",
        attribute: "priceUsd"
    },
    {
        label: "Notes",
        attribute: "notes"
    },
    {
        label: "Category",
        attribute: "category"
    },
    {
        label: "Brand Name",
        attribute: "brandName"
    },
    {
        label: "Gender",
        attribute: "gender"
    },
    {
        label: "Color",
        attribute: "color"
    },
    {
        label: "Color 2",
        attribute: "color2"
    },
    {
        label: "Size",
        attribute: "size"
    },
    {
        label: "Sleeve",
        attribute: "sleeve"
    },
    {
        label: "Collar",
        attribute: "collar"
    },
    {
        label: "Weight (Gram)",
        attribute: "weightGram"
    },
    {
        label: "Weight (Oz)",
        attribute: "weightOz"
    },
    {
        label: "Color Code",
        attribute: "colorCode"
    }
];

export const MARKETS_LIST = [
    {attribute: 'usa', label: 'USA'},
    {attribute: 'india', label: 'India'},
    {attribute: 'canada', label: 'Canada'},
    {attribute: 'europe', label: 'Europe'},
    {attribute: 'uk', label: 'UK'},
    {attribute: 'japan', label: 'Japan'},
    {attribute: 'australia', label: 'Australia'},
    {attribute: 'brazil', label: 'Brazil'},
];

export const PARENT_PRODUCT_FIELD_LIST = [
    {attribute: 'name', label: 'Name', type: 'text', readOnly: true, group: 'info', notAvailable: 'notAvailable'},
    {attribute: 'description', label: 'Description', type: 'text-area', hideInList: true, group: 'detail', rows: 12},
    {attribute: 'productType', label: 'Product Type', type: 'text', readOnly: true, group: 'info'},
    {attribute: 'category', label: 'Category', type: 'text', readOnly: true, group: 'info'},
    {attribute: 'colors', label: 'Colors', type: '', hideInList: true, isList: true, group: 'list'},
    {attribute: 'sizes', label: 'Sizes', type: '', hideInList: true, isList: true, group: 'list'},
    {attribute: 'total', label: 'Total Products', type: 'number', readOnly: true, group: 'total'},
    {attribute: 'totalColors', label: 'Total Colors', type: 'number', readOnly: true, group: 'total'},
    {attribute: 'totalSizes', label: 'Total Sizes', type: 'number', readOnly: true, group: 'total'},
    {
        attribute: 'widthInch',
        label: 'Width (Inch)',
        type: 'number',
        isEditable: true,
        group: 'measurement'
    },
    {
        attribute: 'heightInch',
        label: 'Height (Inch)',
        type: 'number',
        isEditable: true,
        group: 'measurement'
    },
    {attribute: 'widthPixel', label: 'Width (Pixel)', type: 'number', readOnly: true, group: 'measurement'},
    {attribute: 'heightPixel', label: 'Height (Pixel)', type: 'number', readOnly: true, group: 'measurement'},
];

export const SELECT_PARENT_PRODUCT_FIELD_LIST = [
    {attribute: 'name', label: 'Name', type: 'text', readOnly: true, group: 'info'},
    {attribute: 'description', label: 'Description', type: 'text-area', hideInList: true, group: 'detail', rows: 12},
    {attribute: 'productType', label: 'Product Type', type: 'text', readOnly: true, group: 'info'},
    {attribute: 'category', label: 'Category', type: 'text', readOnly: true, group: 'info'},
    {
        attribute: 'widthInch',
        label: 'Width (Inch)',
        type: 'number',
        isEditable: true,
        group: 'measurement'
    },
    {
        attribute: 'heightInch',
        label: 'Height (Inch)',
        type: 'number',
        isEditable: true,
        group: 'measurement'
    },
    {attribute: 'widthPixel', label: 'Width (Pixel)', type: 'number', readOnly: true, group: 'measurement'},
    {attribute: 'heightPixel', label: 'Height (Pixel)', type: 'number', readOnly: true, group: 'measurement'},
];

export const PARENT_PRODUCT_DETAIL_TABS_LIST = [
    {key: 'details', label: 'Details'},
    {key: 'colors-sizes', label: 'Colors & Sizes'},
    {key: 'facebook-interests', label: 'Facebook Interests'},
];
